import { UpdatePostSummaryStore, updatePostSummaryUseCase } from "./updatePostSummaryUseCase";

const clearPostSummaryUseCase = (store: UpdatePostSummaryStore) =>
    updatePostSummaryUseCase(store, '');

export { clearPostSummaryUseCase }